import databoxLogo from "../../assets/images/DataBox-logo-dark.svg";
import AvatarDropdownMenu from "./AvatarDropdownMenu";
import config from "../../config";

const TopNavigation = () => {
    return (
        <header className="fixed top-0 h-14 w-full flex items-center px-6 border-b border-surface-light-5 bg-surface-light z-40">
            {config.partnerLogoUrl && (
                <img
                    src={config.partnerLogoUrl}
                    alt="Partner logo"
                    className="h-10 p-1"
                />
            )}
            {!config.partnerLogoUrl && (
                <img src={databoxLogo} alt="Databox logo dark" />
            )}
            <div className="ml-auto flex gap-4 md:gap-6">
                {config.organizationLogoUrl && (
                    <img
                        src={config.organizationLogoUrl}
                        alt="Organization logo"
                        className="h-9 p-1"
                    />
                )}
                <AvatarDropdownMenu />
            </div>
        </header>
    );
};

export default TopNavigation;
